import { parseOptionalNonNegativeInt } from '../../parse-optional-non-negative-int.js';
import { parseOptionalNonNegativeNumber } from '../../parse-optional-non-negative-number.js';
import { PART_CONSTRAINTS } from './constraints.js';
import { partCostingEditFormSchema } from './costing-form.js';
export const PART_COSTING_FORM_FIELD_KEYS = Object.keys(partCostingEditFormSchema.shape);
export function toUpdatePartInputFromCostingForm(values, dirtyFields) {
    const parsed = partCostingEditFormSchema.parse(values);
    const input = {};
    if (dirtyFields.stdCost) {
        const stdCost = parseOptionalNonNegativeNumber(parsed.stdCost, PART_CONSTRAINTS.stdCost.label);
        input.stdCost = typeof stdCost === 'number' ? stdCost : null;
    }
    if (dirtyFields.leadTime) {
        const leadTime = parseOptionalNonNegativeInt(parsed.leadTime, PART_CONSTRAINTS.leadTime.label);
        input.leadTime = typeof leadTime === 'number' ? leadTime : null;
    }
    if (dirtyFields.taxId)
        input.taxId = parsed.taxId || null;
    if (dirtyFields.inventoryAccountId)
        input.inventoryAccountId = parsed.inventoryAccountId || null;
    if (dirtyFields.cogsAccountId)
        input.cogsAccountId = parsed.cogsAccountId || null;
    if (dirtyFields.varianceAccountId)
        input.varianceAccountId = parsed.varianceAccountId || null;
    if (dirtyFields.scrapAccountId)
        input.scrapAccountId = parsed.scrapAccountId || null;
    if (dirtyFields.adjustmentAccountId) {
        input.adjustmentAccountId = parsed.adjustmentAccountId || null;
    }
    return input;
}
//# sourceMappingURL=costing-mapper.js.map